import { createUseStyles } from 'react-jss';

import type { Theme } from '@wds/styles';

type Props = { isUserAuthenticated: boolean };
const useStyles = createUseStyles(({ breakpoints, spacing }: Theme) => ({
  headerBox: ({ isUserAuthenticated }: Props) => {
    if (!isUserAuthenticated) {
      return {
        margin: 'auto',
      };
    }
    return {
      display: 'flex',
      paddingLeft: spacing[3],
      paddingRight: spacing[3],
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        flexGrow: 1,
        paddingLeft: 0,
        paddingRight: 0,
      },
    };
  },
  headerLink: ({ isUserAuthenticated }) => {
    if (!isUserAuthenticated) {
      return {};
    }
    return {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        paddingLeft: spacing[7],
        paddingRight: spacing[7],
        justifyContent: 'flex-start',
      },
    };
  },
  headerLogo: ({ isUserAuthenticated }: Props) => {
    if (!isUserAuthenticated) {
      return {};
    }

    return {
      paddingLeft: spacing[3],
      paddingRight: spacing[3],
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    };
  },
}));

export default useStyles;
